<mat-card class="feature-card" [class.feature-card--highlight]="variant() === 'highlight'">
  <mat-card-content>
    @if (icon()) {
      <div class="feature-card__icon">
        <mat-icon>{{ icon() }}</mat-icon>
      </div>
    }
    <h3 class="feature-card__title">{{ title() }}</h3>
    <p class="feature-card__desc">{{ description() }}</p>
  </mat-card-content>
</mat-card>
